import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import Page from '@/components/layout/Page';
import PageLoading from '@/components/layout/PageLoading';
import BackButton from '@/components/common/BackButton';
import HorizontalLogo from '@/components/common/HorizontalLogo';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';

import ContractorAgreementForm from './components/coachActivityContractorAgreementPage/ContractorAgreementForm';

import { useApplication } from '@/data/application';
import { useCoachSelf } from '@/data/coach';
import {
  useCoachActivity,
  useCoachActivityContract
} from '@/data/coachActivity';

const CoachActivityContractorAgreementPage = () => {
  const coach = useCoachSelf();
  const params = useParams();
  const coachActivity = useCoachActivity(params.coachActivityId);
  const coachActivityContract = useCoachActivityContract(
    params.coachActivityId
  );
  const applicationStructure = useApplication({
    coachActivityId: params.coachActivityId
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (coach.isLoading && !coach.data) {
    return <PageLoading />;
  }
  if (coachActivityContract.isLoading && !coachActivityContract.data) {
    return <PageLoading />;
  }
  if (coachActivity.isLoading && !coachActivity.data) {
    return <PageLoading />;
  }
  if (applicationStructure.isLoading && !applicationStructure.data) {
    return <PageLoading />;
  }

  return (
    <Page>
      <BackButton to={`/application/${params.coachActivityId}`} />
      <div className="p-8">
        <HorizontalLogo />
      </div>
      <Card>
        <CardHeader>
          <CardTitle>
            INDEPENDENT CONTRACTOR AGREEMENT (
            {coachActivity.data.activity.title})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ContractorAgreementForm />
        </CardContent>
      </Card>
      <div className="flex justify-center py-8"></div>
    </Page>
  );
};

export default CoachActivityContractorAgreementPage;
